import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { isClientSide } from "@utils";

const ZapierZapsDIV = styled.div`
  margin: 60px 0;
`;

class ZapierZaps extends React.Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
    this.idsArray = this.props.ids.split(',');
    this.divId = `zap_${this.idsArray.join('_')}`;
    this.src = `https://zapier.com/zapbook/embed/widget.js?guided_zaps=${this.props.ids}&html_id=${this.divId}`;
    this.zapierScript = null;
  }

  componentDidMount() {
    if (isClientSide()) {
      this.zapierScript = document.createElement('script')
      this.zapierScript.type = 'text/javascript'
      this.zapierScript.src = this.src;
      this.ref.current.appendChild(this.zapierScript);
    }
  }

  render() {
    return (
      <ZapierZapsDIV id={this.divId} ref={this.ref} />
    );
  }
};

ZapierZaps.propTypes = {
  ids: PropTypes.string.isRequired,
};

export default ZapierZaps;
